import { z } from "zod";
import { addressSchema } from "./address.js";
import { shareLinkKindSchema } from "./shareLink.js";
import { paginatedResponseSchema } from "../pagination.js";
export const submissionStatusSchema = z.enum(["pending", "approved", "rejected"]);
// The shape posted to /public/share/:token. Free-form by design, but we
// type the common fields so the moderation UI can render them predictably.
export const submissionPayloadSchema = z.object({
    name: z.string().optional(),
    email: z.string().email().optional(),
    phone: z.string().optional(),
    address: addressSchema.optional(),
    notes: z.string().optional(),
    custom: z.record(z.unknown()).optional(),
});
/**
 * Body for the public POST /public/share/:token. The submission payload plus an
 * optional `accessCode` carried alongside it (the server re-verifies the code
 * before storing anything; it is never persisted on the submission).
 */
export const publicSubmitBodySchema = submissionPayloadSchema.extend({
    accessCode: z.string().optional(),
});
export const submissionSchema = z.object({
    id: z.string(),
    shareLinkId: z.string(),
    payload: submissionPayloadSchema,
    status: submissionStatusSchema,
    resolvedContactId: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const approveSubmissionBodySchema = z.object({
    contactId: z.string().nullable().optional(),
});
/**
 * An existing contact a pending submission likely refers to, so the owner can
 * merge instead of creating a duplicate. `reason` records what matched (email
 * ranks above name).
 */
export const submissionMatchSchema = z.object({
    contactId: z.string(),
    name: z.string().nullable(),
    email: z.string().nullable(),
    reason: z.enum(["email", "name"]),
});
/**
 * Submission as returned to the owner's review UI: the stored row plus the
 * originating link's `kind` and any duplicate-contact `matches` (computed for
 * pending rows only).
 */
export const submissionResponseSchema = submissionSchema.extend({
    shareLinkKind: shareLinkKindSchema,
    matches: z.array(submissionMatchSchema),
});
export const submissionListResponseSchema = paginatedResponseSchema(submissionResponseSchema);
//# sourceMappingURL=submission.js.map